import React from 'react';
import { connect } from 'react-redux';
import { A_ARC } from '@lba-dev/package.local-globals/aStatus';

import useArchiveHistory from './useArchiveHistory';
import ArchiveInfoDisplay from './ArchiveInfoDisplay';

const mapStateToProps = ({ users }) => ({ users });

const ArchiveMenu = ({ elem, users }) => {
  const { user, reason, date } = useArchiveHistory(elem._id, users);

  if (elem.status !== A_ARC || !elem.date.archive || !elem.login.archive) {
    return <div>Cet artisan n'est pas archivé</div>;
  }

  return <ArchiveInfoDisplay user={user} date={date} reason={reason} />;
};

export default connect(mapStateToProps)(ArchiveMenu);
